import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/Login.css";
import builderImg from "../assets/img/builderimg.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import { toast } from 'react-toastify';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const navigate = useNavigate();

  // Load saved credentials on mount (matches React Native app)
  useEffect(() => {
    loadSavedCredentials();
  }, []);

  const loadSavedCredentials = async () => {
    try {
      const savedEmail = localStorage.getItem('rememberedEmail');
      const savedPassword = localStorage.getItem('rememberedPassword');
      const savedRememberMe = localStorage.getItem('rememberMe');

      if (savedRememberMe === 'true' && savedEmail && savedPassword) {
        setEmail(savedEmail);
        setPassword(savedPassword);
        setRememberMe(true);
      }
    } catch (error) {
      console.error('Error loading saved credentials:', error);
    }
  };

  const saveCredentials = async () => {
    try {
      if (rememberMe) {
        localStorage.setItem('rememberedEmail', email);
        localStorage.setItem('rememberedPassword', password);
        localStorage.setItem('rememberMe', 'true');
      } else {
        // Clear saved credentials if remember me is unchecked
        localStorage.removeItem('rememberedEmail');
        localStorage.removeItem('rememberedPassword');
        localStorage.removeItem('rememberMe');
      }
    } catch (error) {
      console.error('Error saving credentials:', error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    // Basic validation (matches React Native app)
    if (!email || !password) {
      setLoginError('Please enter both email and password');
      return;
    }

    if (!email.includes('@')) {
      setLoginError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setLoginError('');

    try {
      // Save credentials if remember me is checked
      await saveCredentials();

      // Prepare login payload object matching mobile app
      const loginPayload = {
        email,
        password,
        fcmToken: "etTQzqJTRZu9gBbe2om6Mc:APA91bG1BQGGQ_uRryVzKAG_JLOqjtNA08getuLDkAXOJuBtO1AMzbhwCT-_P1LJFIl1TzD8YqEyKC9tFpglw_egEJRE6RQDOmon4OspnOIpta02yp7kZuw",
        fcm_platform: "android"
      };

      // Call admin-specific auth API (matches React Native app)
      const response = await authService.adminLogin(loginPayload);

      if (response.success) {
        // User role and session are stored by adminLogin method
        // Navigate to admin dashboard (matches React Native navigation)
        navigate('/Webadmindashboard');
      } else {
        setLoginError(response.message || 'Invalid admin credentials');
      }
    } catch (error) {
      console.error('Admin login error:', error);

      // Don't use fallback demo mode (matches React Native app behavior)
      if (email === 'admin@rebax.com' && password === 'admin123') {
        toast.error('Connection Error: Cannot connect to server. Please check your internet connection and try again.');
        return;
      }

      setLoginError(error.message || 'Login failed. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setShowForgotPasswordModal(true);
    setForgotPasswordEmail('');
  };

  const handleSubmitForgotPassword = async () => {
    if (!forgotPasswordEmail) {
      toast.warning('Please enter your email address');
      return;
    }

    if (!forgotPasswordEmail.includes('@')) {
      toast.warning('Please enter a valid email address');
      return;
    }

    setForgotPasswordLoading(true);

    try {
      const response = await authService.forgotPassword(forgotPasswordEmail);

      if (response.success) {
        setShowForgotPasswordModal(false);
        toast.success('Login credentials have been sent to your email address. Please check your inbox.');
      } else {
        toast.error(response.message || 'Failed to send email. Please try again.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      toast.error(error.message || 'Something went wrong. Please try again later.');
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  return (
    <div className="builder-login-container">
      {/* Left Column */}
      <div className="left-col1 d-flex flex-column justify-content-center align-items-center text-center">
        <h1 className="builder-title mb-4 " style={{ marginTop: "140px" }}>
          Login as Admin
        </h1>
        <img src={builderImg} alt="Builder" className="builder-img mt-4" />
      </div>

      {/* Right Column */}
      <div className="right-col d-flex flex-column justify-content-center align-items-center">
        {/* Tabs */}
        <div className="tab-container">
          <div className="tab-active">Login</div>
          <div
            className="tab-inactive"
            onClick={() => navigate("/Adminregistration")}
            style={{ cursor: "pointer" }}
          >
            Register
          </div>
        </div>

        {/* Error Message */}
        {loginError && (
          <div className="alert alert-danger mb-3" role="alert">
            {loginError}
          </div>
        )}

        {/* Form */}
        <form className="login-form mt-4" onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label login-label-text">Email / Phone</label>
            <input
              type="text"
              className="form-control custom-input login-builder-input"
              placeholder="Enter Email/phone"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className="mb-3 position-relative">
            <label className="form-label login-label-text">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control custom-input login-builder-input"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              style={{ cursor: 'pointer' }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye/>}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                id="remember"
                style={{ width: "18px", height: "18px" }}
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                disabled={loading}
              />
              <label htmlFor="remember" className="ms-2 builder-login-remember">
                Remember me
              </label>
            </div>

            <button
              type="button"
              className="btn btn-link p-0 forgot-link builder-forgot-pass"
              onClick={handleForgotPassword}
              disabled={loading}
            >
              Forgot password?
            </button>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            className="login-btn w-100 mt-4"
            disabled={loading}
          >
            <span className="login-btn-text">
              {loading ? 'Logging in...' : 'Login'}
            </span>
          </button>
        </form>
      </div>

      {/* Forgot Password Modal (matches React Native app) */}
      {showForgotPasswordModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Forgot Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowForgotPasswordModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p className="text-muted mb-3">
                  Enter your email address and we'll send your login credentials to your inbox.
                </p>
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={forgotPasswordEmail}
                    onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    autoFocus
                    disabled={forgotPasswordLoading}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowForgotPasswordModal(false)}
                  disabled={forgotPasswordLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitForgotPassword}
                  disabled={forgotPasswordLoading}
                >
                  {forgotPasswordLoading ? 'Sending...' : 'Send Email'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
